// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"../../../styles/colors.css\"","netsurfMint":"#60FEB2"};